/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsRunJob,
    EfsMelcoEfsModelsRunJobFromJSON,
    EfsMelcoEfsModelsRunJobFromJSONTyped,
    EfsMelcoEfsModelsRunJobToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsRun
 */
export interface EfsMelcoEfsModelsRun {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsRun
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsRun
     */
    computer_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoEfsModelsRun
     */
    start_time?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoEfsModelsRun
     */
    end_time?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoEfsModelsRun
     */
    client_start_time?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoEfsModelsRun
     */
    client_end_time?: Date;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoEfsModelsRun
     */
    jobs?: number;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoEfsModelsRun
     */
    files?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsRun
     */
    status?: string | null;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsRunJob>}
     * @memberof EfsMelcoEfsModelsRun
     */
    job_list?: Array<EfsMelcoEfsModelsRunJob> | null;
}

export function EfsMelcoEfsModelsRunFromJSON(json: any): EfsMelcoEfsModelsRun {
    return EfsMelcoEfsModelsRunFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsRun {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'computer_name': !exists(json, 'computer_name') ? undefined : json['computer_name'],
        'start_time': !exists(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'end_time': !exists(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'client_start_time': !exists(json, 'client_start_time') ? undefined : (new Date(json['client_start_time'])),
        'client_end_time': !exists(json, 'client_end_time') ? undefined : (new Date(json['client_end_time'])),
        'jobs': !exists(json, 'jobs') ? undefined : json['jobs'],
        'files': !exists(json, 'files') ? undefined : json['files'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'job_list': !exists(json, 'job_list') ? undefined : (json['job_list'] === null ? null : (json['job_list'] as Array<any>).map(EfsMelcoEfsModelsRunJobFromJSON)),
    };
}

export function EfsMelcoEfsModelsRunToJSON(value?: EfsMelcoEfsModelsRun | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'computer_name': value.computer_name,
        'start_time': value.start_time === undefined ? undefined : (value.start_time.toISOString()),
        'end_time': value.end_time === undefined ? undefined : (value.end_time.toISOString()),
        'client_start_time': value.client_start_time === undefined ? undefined : (value.client_start_time.toISOString()),
        'client_end_time': value.client_end_time === undefined ? undefined : (value.client_end_time.toISOString()),
        'jobs': value.jobs,
        'files': value.files,
        'status': value.status,
        'job_list': value.job_list === undefined ? undefined : (value.job_list === null ? null : (value.job_list as Array<any>).map(EfsMelcoEfsModelsRunJobToJSON)),
    };
}


